module.exports = __webpack_public_path__ + "static/media/sms_selected.99f989b7.svg";